// Helper para gerar link wa.me com mensagem pré-preenchida.
function normalizePhone(phone) {
  if (!phone) return "";
  const digits = String(phone).replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("55") && digits.length >= 12) return digits;
  if (digits.length === 10 || digits.length === 11) return `55${digits}`;
  return digits;
}

export function whatsappLink(phone, message = "") {
  const num = normalizePhone(phone);
  if (!num) return null;
  const base = `https://wa.me/${num}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}

const MONTHS_PT = [
  "janeiro", "fevereiro", "março", "abril", "maio", "junho",
  "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
];

export function formatMonthBR(monthIso) {
  if (!monthIso || !/^\d{4}-\d{2}$/.test(monthIso)) return monthIso || "";
  const [y, m] = monthIso.split("-");
  const name = MONTHS_PT[Number(m) - 1] || m;
  return `${name}/${y}`;
}

export const DEFAULT_WHATSAPP_TEMPLATE =
  "Olá, {responsavel}! Aqui é da escola Vôlei Vida. " +
  "Passando para lembrar que a mensalidade do(a) {nome} referente a {mes}, no valor de R$ {valor}, está {situacao}. " +
  "O vencimento é todo dia 10. Qualquer dúvida estamos à disposição. Obrigado!";

function brl(amount) {
  if (amount == null || amount === "") return "0,00";
  return Number(amount).toFixed(2).replace(".", ",");
}

export function renderWhatsappMessage(template, { studentName, guardianName, month, amount, situation }) {
  const tpl = (template && template.trim()) || DEFAULT_WHATSAPP_TEMPLATE;
  return tpl
    .replaceAll("{responsavel}", guardianName ? guardianName : "responsável")
    .replaceAll("{nome}", studentName || "")
    .replaceAll("{mes}", formatMonthBR(month))
    .replaceAll("{valor}", brl(amount))
    .replaceAll("{situacao}", situation || "pendente");
}

// Status computado: pago / a_vencer / atrasado
export function computePaymentDisplayStatus({ status, month, dueDay = 10, today = new Date() }) {
  if (status === "pago") return "pago";
  if (!month || !/^\d{4}-\d{2}$/.test(month)) return "a_vencer";
  const [y, m] = month.split("-").map(Number);
  const due = new Date(y, m - 1, dueDay, 23, 59, 59, 999);
  return today > due ? "atrasado" : "a_vencer";
}

export const STATUS_LABEL = { pago: "Pago", a_vencer: "A vencer", atrasado: "Atrasado" };
export const STATUS_CHIP = {
  pago: "vv-chip-lime",
  a_vencer: "vv-chip-yellow",
  atrasado: "vv-chip-red",
};
